// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__15ird","title":"FrontImage_title__gNE--"};